// extracted by mini-css-extract-plugin
module.exports = {"profile":"Profile_profile__2VM8b","avatar":"Profile_avatar__27k2E","header":"Profile_header__19a23","friendList":"Profile_friendList__i-c4Y"};